import * as React from "react"
import { connect } from "react-redux"

import OldUIContext from "../../../olduicontext"
import { GlobalState } from "../../../store"

import { DispatchProps, mapDispatchToProps } from "../actions"

import CreateNewItemCard from "./CreateNewItemCard"
import ItemCard from "./ItemCard"
import LoadMoreCard from "./LoadMoreCard"
import { ICardView } from "../index"

type StateProps = ICardView

type Props = StateProps & DispatchProps

export class CardView extends React.Component<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const { items, paging, allowAdd, loadMore } = this.props

        return (
            <div className="tw-p-2">
                <div className="tw-flex tw-flex-wrap tw--mx-1 tw--mb-1">
                    {items.map((item) => {
                        return <ItemCard item={item} key={item.id} />
                    })}

                    {items.length > 0 && (
                        <LoadMoreCard pagingInfo={paging} loadMore={loadMore} />
                    )}
                    {allowAdd && <CreateNewItemCard />}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.cardView,
})

export default connect(mapStateToProps, mapDispatchToProps)(CardView)
